import type { ReactNode } from 'react';

/**
 * SP-8a — Wrapper grafico per i filtri di pagina nella sidebar sinistra.
 *
 * Pattern d'uso:
 * ```tsx
 * <PageFilters>
 *   <FilterSection title="Cerca">
 *     <Input ... />
 *   </FilterSection>
 *   <FilterSection title="Stato">
 *     <Select isMulti ... />
 *   </FilterSection>
 * </PageFilters>
 * ```
 *
 * Lo styling (titoletti uppercase piccoli, spacing) viene dal CSS
 * `.vp-page-filters__*` in vp-custom.scss.
 */
export interface PageFiltersProps {
  children: ReactNode;
  /** Stringa opzionale mostrata in fondo (es. "7 di 7 distinte"). */
  footer?: ReactNode;
}

export function PageFilters({ children, footer }: PageFiltersProps) {
  return (
    <div className="vp-page-filters">
      {children}
      {footer !== undefined && (
        <div className="vp-page-filters__footer mt-3 small text-muted">{footer}</div>
      )}
    </div>
  );
}

export interface FilterSectionProps {
  /** Titolo sezione (uppercase piccolo). */
  title: string;
  children: ReactNode;
}

export function FilterSection({ title, children }: FilterSectionProps) {
  return (
    <div className="vp-page-filters__section">
      <div className="vp-page-filters__title">{title}</div>
      <div className="vp-page-filters__body">{children}</div>
    </div>
  );
}
